import { Button } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../store/slices/homeSlice";

const TabsBox = () => {
  const { tabs, activeTab } = useSelector((state) => state.home);
  const dispatch = useDispatch();

  return (
    <div className="tabsContainer">
      {tabs.map((tab, index) => {
        return (
          <Button
            onClick={() => dispatch(setActiveTab(tab.title))}
            key={index}
            className={tab.title === activeTab ? "activeTab" : ""}
          >
            {tab.title}
          </Button>
        );
      })}
    </div>
  );
};

export default TabsBox;
